module.exports = __webpack_public_path__ + "static/media/procedure_icon_yellow.c6a5024c.png";